<template>
  <delegation-form ref="delegationForm" />
</template>

<script>
import DelegationForm from "../../components/Delegation/DelegationForm";
export default {
  name: "DelegationNewView",
  components: { DelegationForm },
  beforeRouteLeave(from, to, next) {
    this.$refs.delegationForm.beforeRouteLeave(from, to, next);
  }
};
</script>

<style scoped></style>
